import { FileWithPreview } from "src/components/DropZone/DropZone";

export interface AddNewApplicationResponse {
  success: boolean;
  message: string;
  redirectUrl: string;
}

export interface AddNewApplicationBody {
  [key: string]: string | File | File[] | undefined | null;
  card_id_file?: File;
  personal_pic?: File;
  extra_files?: File[];
}

const apiUrl = "https://dotmedica.com/applications/addNewApplication";

export const addNewApplication = async (
  body: AddNewApplicationBody
): Promise<AddNewApplicationResponse> => {
  try {
   const formData = new FormData();

    Object.entries(body).forEach(([key, value]) => {
      if (value === undefined || value === null) return;

      // multiple files
      if (Array.isArray(value)) {
        value.forEach((file) => {
          formData.append(`${key}[]`, file);
        });
      }
      // single file
      else if (value instanceof File) {
        formData.append(key, value);
      }
      // text
      else {
        formData.append(key, value);
      }
    });

    const response = await fetch(apiUrl, {
      method: "POST",
      body: formData, 
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error(error);
    throw error;
  }
};
